import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "7.2",
      cy: "7.2",
      r: "2.4"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16.8",
      cy: "7.2",
      r: "2.4"
    }, null, -1),
    _createElementVNode("path", { d: "m8.6 8.8 6.8 9.2m0-9.2L8.6 18M10.2 18h3.6" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-grooming"}) } }